var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4674 103C43.9434 103 51.6341 95.3093 51.6341 85.8334V68.6667H34.4674C24.9914 68.6667 17.3008 76.3574 17.3008 85.8334C17.3008 95.3093 24.9914 103 34.4674 103Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3008 51.5C17.3008 42.024 24.9914 34.3333 34.4674 34.3333H51.6341V68.6666H34.4674C24.9914 68.6666 17.3008 60.976 17.3008 51.5Z",
    fill: "#303030"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3008 17.1667C17.3008 7.69067 24.9914 0 34.4674 0H51.6341V34.3333H34.4674C24.9914 34.3333 17.3008 26.6427 17.3008 17.1667Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6341 0H68.8008C78.2768 0 85.9675 7.69067 85.9675 17.1667C85.9675 26.6427 78.2768 34.3333 68.8008 34.3333H51.6341V0Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9675 51.5C85.9675 60.976 78.2768 68.6666 68.8008 68.6666C59.3248 68.6666 51.6341 60.976 51.6341 51.5C51.6341 42.024 59.3248 34.3333 68.8008 34.3333C78.2768 34.3333 85.9675 42.024 85.9675 51.5Z",
    fill: "#303030"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.214d0b75a722c0bb1e11d2736b97523f.svg";
export { ForwardRef as ReactComponent };